/* eslint-disable react/jsx-no-bind */
import React, { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { IConfigOption } from '../types';

const Container = styled(Box)(({ theme }) => ({
  margin: 'auto',
  borderRadius: '10px',
  padding: '15px',
  maxWidth: '1100px',
  position: 'relative',
  zIndex: 100,
  paddingBottom: '30px',
  overflow: 'hidden',
  marginBottom: '30px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

const Title = styled(Box)(`
  font-size: 1.5em;
  text-align: center;
  margin: 0.5em;
`);

const SubTitle = styled(Box)(`
  text-align: center;
`);

interface IChooseConfiguration {
  handleConfigurationSubmit: (emailVal: string, config: IConfigOption) => void;
}

export const ChooseConfiguration = ({
  handleConfigurationSubmit,
}: IChooseConfiguration) => {
  const [email, setEmail] = useState('');

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const [configOptions] = useState<IConfigOption>({
    liveSlides: true,
    polls: true,
    preRecord: true,
    questions: true,
    screenshare: true,
    webcam: true,
  });

  const handleFormSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      handleConfigurationSubmit(email, configOptions);
      console.log('Form submitted with:', { email, configOptions });
    },
    [configOptions, email, handleConfigurationSubmit],
  );

  return (
    <form onSubmit={handleFormSubmit}>
      <Container>
        <Title>About You</Title>
        <SubTitle>
          Please tell us your email address, this will help us reach out to you
          to help if you need it
        </SubTitle>
        <br />
        <Box sx={{ textAlign: 'center' }}>
          <Box>
            <Typography gutterBottom={true} variant="subtitle1">
              Email Address
            </Typography>
            <TextField
              onChange={handleEmailChange}
              required={true}
              sx={{ width: '300px' }}
              type="email"
              value={email}
            />
          </Box>
        </Box>
        <Box margin={2} textAlign="center">
          <Button color="primary" type="submit" variant="contained">
            Next
          </Button>
        </Box>
      </Container>
    </form>
  );
};
